import { Link } from "react-router-dom";
import { useTenant } from "@/contexts/TenantContext";
import { cfImage } from "@/lib/utils";

interface AppLogoProps {
  width?: number;
  height?: number;
  imgClassName?: string;
  variant?: "default" | "stacked";
}

export const AppLogo = ({
  width = 280,
  height,
  imgClassName,
  variant = "default",
}: AppLogoProps) => {
  const { tenant } = useTenant();
  const logoSrc =
    variant === "stacked"
      ? tenant.branding?.signInLogo ?? tenant.branding?.logos?.wordmark
      : tenant.branding?.logos?.wordmark;
  const siteTitle = tenant.branding?.siteTitle || "Travel";

  if (!logoSrc) {
    return (
      <Link to="/" className="text-white text-xl font-bold">
        {siteTitle}
      </Link>
    );
  }

  return (
    <Link to="/">
      <img
        src={cfImage(logoSrc, { width, quality: 90 })}
        alt={siteTitle}
        style={{ width, height: "auto", maxHeight: height }}
        className={`block object-contain max-[375px]:w-[200px] max-[375px]:h-auto ${imgClassName ?? ""}`}
      />
    </Link>
  );
};

export default AppLogo;
